import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IUserIdentityConfirmRequest } from '~/@api/generated-api-types-user/Api'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

function useIdentityConfirmation() {
  const client = useApiClientUser()

  const identityConfirmationMutation = useMutation({
    mutationFn: async (data: IUserIdentityConfirmRequest) => {
      return await client.user.onboardingControllerConfirmIdentity(data, {
        secure: true,
      })
    },
  })

  const errorMessage = getApiErrorMessage(
    identityConfirmationMutation.error,
    'Identitu sa nepodarilo potvrdiť.'
  )

  return {
    mutation: identityConfirmationMutation.mutate,
    isPending: identityConfirmationMutation.isPending,
    error: errorMessage,
  }
}

export { useIdentityConfirmation }
